import defaultFile_icon from "../assets/images/mediafiles/default_icon.svg";
import imageFile_logo from "../assets/images/mediafiles/image.svg";
import youtubeFile_logo from "../assets/images/mediafiles/youtubeFile_logo.svg";
import powerpointFile_logo from "../assets/images/mediafiles/powerpointFile_logo.svg";
import pdfFile_logo from "../assets/images/mediafiles/pdf_icon.svg";
import mswordFile_logo from "../assets/images/mediafiles/mswordFile_logo.svg";
import excelFile_logo from "../assets/images/mediafiles/msExcel_.svg";
import googleFile_logo from "../assets/images/mediafiles/googleFile_logo.svg";

export function getFileIcons(extension) {
  switch (extension) {
    case "pdf":
      return pdfFile_logo;
    case "doc":
    case "docx":
      return mswordFile_logo;
    case "txt":
      return defaultFile_icon;
    case "xls":
    case "xlsx":
      return excelFile_logo;
    case "ppt":
    case "pptx":
      return powerpointFile_logo;
    case "zip":
    case "rar":
    case "7z":
    case "tar":
    case "gz":
    case "eps":
    case "ai":
    case "psd":
    case "ico":
    case "svg":
    case "webp":
    case "gif":
    case "tiff":
    case "jpg":
    case "jpeg":
    case "png":
    case "dart":
      return imageFile_logo;
    default:
      return "unknown"; // You can define a default icon for unknown file types
  }
}

function identifyGoogleOrYouTube(url) {
  // Regular expressions to match YouTube URLs
  const youtubeRegex = /https:\/\/(www\.)?youtube\.com/;

  // Check for YouTube link
  if (youtubeRegex.test(url)) {
    return youtubeFile_logo;
  }
  // Check if it's a .com link (including any .com like Google, oscommerce, etc.)
  else if (url.includes(".com")) {
    return googleFile_logo; // Treat any .com as Google-like
  }
  // Default case for non .com links
  else {
    return defaultFile_icon;
  }
}

export function getFileIconUrl(fileUrl) {
  if (fileUrl) {
    const fileExtension = fileTypeCheck(fileUrl);
    if (fileExtension) {
      // Check if the file is an audio file
      if (
        fileExtension === "mp3" ||
        fileExtension === "m4a" ||
        fileExtension === "wav" ||
        fileExtension === "ogg" ||
        fileExtension === "webm"
      ) {
        return "audio"; // Return 'audio' as an identifier for audio files
      }
      const icon = getFileIcons(fileExtension);
      if (icon === "unknown") {
        const updatedIcon = identifyGoogleOrYouTube(fileUrl);
        return updatedIcon;
      }

      return icon;
    }
  }
  return defaultFile_icon;
}

function fileTypeCheck(fileUrl) {
  const pathWithoutQuery = fileUrl.split("?")[0];
  const fileExtension = pathWithoutQuery.split(".").pop().toLowerCase();
  return fileExtension;
}

export function isGoogleYoutubeUrl(fileUrl) {
  try {
    new URL(fileUrl);
    return true;
  } catch {
    return false;
  }
}

export const FILE_CATEGORY = {
  ALL: "all",
  DOCS: "docs",
  MEDIA: "media",
  LINKS: "links",
  DRIVE: "drive",
};

// Hostnames a "share as link" cloud-storage item can carry (see
// CloudStorageDrawer.jsx). Upload-copy imports go through the same GCS
// upload path as a direct upload and carry no such marker, so they cannot be
// distinguished from a regular upload here.
const CONNECTED_DRIVE_HOSTS = [
  "drive.google.com",
  "docs.google.com",
  "onedrive.live.com",
  "1drv.ms",
  "sharepoint.com",
];

function getUrlHostname(url) {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch {
    return null;
  }
}

// Uploaded/imported files always carry `mimeType` (stamped by the backend's
// GCS upload); link-type attachments (YouTube, Drive/OneDrive "share as
// link") never do — that presence/absence is the reliable signal here,
// extension sniffing is not needed for it.
export function getAttachmentCategory(item) {
  const mimeType = item?.mimeType;
  if (mimeType) {
    return /^(image|video|audio)\//.test(mimeType)
      ? FILE_CATEGORY.MEDIA
      : FILE_CATEGORY.DOCS;
  }
  const hostname = getUrlHostname(item?.location);
  if (hostname && CONNECTED_DRIVE_HOSTS.some((host) => hostname.endsWith(host))) {
    return FILE_CATEGORY.DRIVE;
  }
  return FILE_CATEGORY.LINKS;
}

export function handleOpenFile(dispatch, fileData, handleMediaDownload) {
  const reqBody = {
    location: fileData?.location,
  };
  dispatch(handleMediaDownload(reqBody)).then((fileUrl) => {
    if (fileUrl?.data) {
      window.open(fileUrl?.data, "_blank");
    }
  });
}
